<template>
  <v-app>
    <NavBar />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components: { NavBar },
}
</script>

<style>
* {
  font-family: 'Inter', 'Roboto', sans-serif;
}

html {
  scroll-behavior: smooth;
}

body {
  background: #ffffff;
}

.section-title {
  font-size: 2.2rem;
  font-weight: 800;
  color: #1a1a2e;
  line-height: 1.2;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.7;
}
</style>
